import { isWithin } from "./time";
import moment from "moment";

export const getPeriodStatus = (period) => {
  if (isWithin(period?.time?.earn)) {
    return "ongoing";
  }
  return moment().isAfter(period?.time?.earn?.end) ? "earnEnded" : "pending";
};

export const formatProductWithAvailableQty = (product, gifts = []) => {
  if (!product || !product.id || !product.qty) {
    throw new Error("Invalid product object provided");
  }

  // Set default value for estamp if it is undefined or 0
  const estampQty = product.qty.estamp || 0;

  // Calculate total qty used in gifts for the specific product
  const totalGiftQty = gifts.reduce((acc, gift) => {
    if (gift.productId === product.id) {
      acc += gift.qty;
    }
    return acc;
  }, 0);

  // Calculate available quantity
  const availableQty = estampQty - totalGiftQty;

  return {
    ...product,
    qty: {
      ...product.qty,
      available: Math.max(availableQty, 0), // Ensure available qty is non-negative
    },
  };
};

